export class PrescriptionNonStandard {
    public idPrescriptionNonStandard: number;
    public idMedicalCare: number;
    public idMultiProfessionalCare: number;
    public idEpisode: number;
    public idUser: number;
    public formattedText: string;
    public dateTimeInclusion: Date;
}